import useErrorReporting from "../../../../shared/General/components/ErrorReporting/useErrorReporting";

export function useEmbeddedEvents() {
    const {reportError} = useErrorReporting();

    const postEmbeddedMessage = (name: string, data: unknown) => {
        const isEmbedded = window.parent !== window;
        if (!isEmbedded) return;

        try {
            window.parent.postMessage({name, data}, document.referrer || "*");
        } catch (error) {
            reportError(error);
            console.error(error);
        }
    };

    return postEmbeddedMessage;
}
